module.exports = __webpack_public_path__ + "static/media/1moneysign-white.4591466a.svg";